(function () {
    'use strict';

    angular.module("imApp").factory("choiceProdPriceGrpsService", ['$ihttp', function ($ihttp) {
        let service = {
            listPriceGroups: function (parms) {
                return $ihttp.post({
                    method: 1200,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
